module.exports = __webpack_public_path__ + "static/assets/cc4f8c9c6365f454f917f76d4852617b.png";